var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sidebar"}},[_c('div',{staticClass:"sidebar",class:_vm.menuOpen ? 'visible' : 'invisible'},[_c('ul',{staticClass:"margin-t"},_vm._l((_vm.menu),function(item){return _c('li',{key:item.id,on:{"click":_vm.setMenu}},[_c('a',{attrs:{"href":item.path}},[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }